import BaseApi from './BaseApi';

class OrderChangeApi extends BaseApi {

  changeOrder(orderId: number, data = {}) {
    return this.post(`orders/${orderId}/recreate`, data);
  }

  makeDelivery(orderId: number | string, data = {}) {
    return this.post(`orders/${orderId}/make-delivery`, data);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/';
  }
}

export default OrderChangeApi;
